<div class="min-h-full bg-[#fafaf7] font-sans">

  @if (isLoading()) {
    <div class="flex items-center justify-center min-h-[60vh]">
      <div class="relative w-10 h-10">
        <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
        <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
      </div>
    </div>
  }

  @if (!isLoading() && document()) {
    <!-- Top bar -->
    <div class="max-w-[1200px] mx-auto px-5 sm:px-8 pt-8 pb-4">
      <div class="fiche-titlebar grid grid-cols-3 items-center">

        <!-- Back -->
        <div class="justify-self-start">
          <button (click)="goBack()" class="flex items-center gap-2 text-stone-400 hover:text-primary-600 transition-colors cursor-pointer">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
            </svg>
            <span class="text-[11px] font-bold uppercase tracking-wider">Retour aux documents</span>
          </button>
        </div>

        <!-- Title -->
        <div class="justify-self-center">
          <h1 class="text-lg font-semibold text-stone-800">Document public</h1>
        </div>

        <!-- Actions -->
        <div class="justify-self-end flex items-center gap-2">
          @if (permService.can('marketing', 'documents', 'status')) {
            @if ((document()!.public_document_status || 'ACTI') !== 'ACTI') {
              <button (click)="confirmStatus('ACTI')" [disabled]="isSaving()"
                class="inline-flex items-center gap-2 px-4 py-2 bg-emerald-600 text-white rounded-xl hover:bg-emerald-700 disabled:opacity-50 transition-colors text-sm font-medium shadow-sm">
                <span class="material-icons text-base">visibility</span>
                Publier
              </button>
            }
            @if ((document()!.public_document_status || 'ACTI') === 'ACTI') {
              <button (click)="confirmStatus('INAC')" [disabled]="isSaving()"
                class="inline-flex items-center gap-2 px-4 py-2 bg-amber-500 text-white rounded-xl hover:bg-amber-600 disabled:opacity-50 transition-colors text-sm font-medium shadow-sm">
                <span class="material-icons text-base">visibility_off</span>
                Dépublier
              </button>
            }
          }
          @if (permService.can('marketing', 'documents', 'edit')) {
            <button (click)="onEdit()" [disabled]="isSaving()"
              class="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-xl hover:bg-primary-700 disabled:opacity-50 transition-colors text-sm font-medium shadow-sm">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931z"/>
              </svg>
              Modifier
            </button>
          }
          @if (permService.can('marketing', 'documents', 'delete')) {
            <button (click)="confirmDelete()" [disabled]="isSaving()"
              class="w-9 h-9 rounded-xl flex items-center justify-center text-stone-400 hover:bg-red-50 hover:text-red-500 disabled:opacity-50 transition-all border border-stone-200" title="Supprimer">
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"/>
              </svg>
            </button>
          }
        </div>

      </div>
    </div>

    <div class="max-w-[1200px] mx-auto px-5 sm:px-8 pb-8 space-y-4">

      @if (errorMessage()) {
        <div class="p-3 rounded-xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-2">
          <span class="material-icons text-base text-red-500">error_outline</span>
          {{ errorMessage() }}
        </div>
      }

      <!-- Meta card -->
      <div class="bg-white rounded-2xl border border-stone-100 shadow-sm px-6 py-5 flex flex-wrap items-start gap-6">
        <div class="flex-1 min-w-0">
          <p class="text-base font-semibold text-stone-800 leading-snug">{{ document()!.public_document_first_title }}</p>
          <p class="text-xs text-stone-400 mt-1">Catégorie : {{ getCategoryLabel(document()!.page_code) }}</p>
          <p class="text-xs text-stone-400 mt-0.5">Ordre d'affichage : {{ document()!.public_document_display_order }}</p>
        </div>
        <div class="flex items-center gap-4 flex-shrink-0">
          <span class="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border"
            [class]="statusBadgeClass(document()!.public_document_status || 'ACTI')">
            <span class="w-1.5 h-1.5 rounded-full flex-shrink-0"
              [class]="(document()!.public_document_status || 'ACTI') === 'ACTI' ? 'bg-emerald-500' : 'bg-amber-400'">
            </span>
            {{ document()!.public_document_status_label || statusLabel(document()!.public_document_status || 'ACTI') }}
          </span>
        </div>
      </div>

      <!-- Document preview -->
      @if (document()!.file_url) {
        <div class="bg-white rounded-2xl border border-stone-100 shadow-sm overflow-hidden">
          <div class="px-5 py-3 border-b border-stone-100 flex items-center justify-between">
            <div class="flex items-center gap-2">
              <span class="material-icons text-stone-400 text-base">description</span>
              <span class="text-xs font-medium text-stone-600">{{ document()!.file_name || 'Document' }}</span>
            </div>
            <a [href]="document()!.file_url" target="_blank" download
              class="inline-flex items-center gap-1.5 text-xs text-primary-600 hover:text-primary-800 font-medium transition-colors">
              <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
              </svg>
              Télécharger
            </a>
          </div>

          @if (fileExt() === 'pdf') {
            <iframe [src]="safePdfUrl()!" class="w-full border-0" style="height: calc(100vh - 280px);" title="Aperçu PDF"></iframe>
          } @else if (['jpg','jpeg','png','gif','webp'].includes(fileExt())) {
            <div class="flex justify-center items-center p-6">
              <img [src]="document()!.file_url" [alt]="document()!.file_name || 'Document'"
                class="max-w-full object-contain rounded-lg shadow" style="max-height: calc(100vh - 320px);" />
            </div>
          } @else {
            <div class="flex flex-col items-center justify-center py-16 gap-4">
              <span class="material-icons text-5xl text-stone-200">description</span>
              <p class="text-stone-500 text-sm">Aperçu non disponible pour ce format.</p>
              <a [href]="document()!.file_url" target="_blank"
                class="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white text-sm font-medium rounded-xl hover:bg-primary-700 transition-colors">
                <span class="material-icons text-base">open_in_new</span>
                Ouvrir le fichier
              </a>
            </div>
          }
        </div>
      } @else {
        <div class="bg-white rounded-2xl border border-stone-100 shadow-sm flex flex-col items-center justify-center py-16 gap-3">
          <span class="material-icons text-4xl text-stone-200">description</span>
          <p class="text-stone-400 text-sm">Aucun fichier joint à ce document.</p>
        </div>
      }

    </div>
  }

  @if (!isLoading() && !document()) {
    <div class="flex flex-col items-center justify-center min-h-[60vh] gap-4">
      <span class="material-icons text-5xl text-stone-200">search_off</span>
      <p class="text-stone-500 text-sm">Document introuvable.</p>
      <button (click)="goBack()" class="text-primary-600 hover:underline text-sm">Retour à la liste</button>
    </div>
  }
</div>

<!-- Status confirm modal -->
@if (pendingStatus()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-sm mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 rounded-2xl flex items-center justify-center flex-shrink-0"
          [class]="pendingStatus()!.status === 'INAC' ? 'bg-amber-50' : 'bg-emerald-50'">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
            [class]="pendingStatus()!.status === 'INAC' ? 'text-amber-500' : 'text-emerald-500'">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </div>
        <div>
          <p class="font-semibold text-stone-800 text-sm">Confirmer le changement</p>
          <p class="text-xs text-stone-500 mt-0.5">
            @if (pendingStatus()!.status === 'INAC') { Ce document sera masqué du site public. }
            @else { Ce document sera visible sur le site public. }
          </p>
        </div>
      </div>
      <div class="flex gap-2 justify-end">
        <button type="button" (click)="cancelStatus()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">
          Annuler
        </button>
        <button type="button" (click)="applyStatus()"
          class="px-4 py-2 text-sm font-medium text-white rounded-xl transition-colors"
          [class]="pendingStatus()!.status === 'INAC' ? 'bg-amber-500 hover:bg-amber-600' : 'bg-emerald-600 hover:bg-emerald-700'">
          {{ pendingStatusLabel(pendingStatus()!.status) }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Delete confirm modal -->
@if (pendingDelete()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
    <div class="bg-white rounded-3xl shadow-xl border border-stone-100 p-6 w-full max-w-sm mx-4">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 rounded-2xl bg-red-50 flex items-center justify-center flex-shrink-0">
          <svg class="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z"/>
          </svg>
        </div>
        <div>
          <p class="font-semibold text-stone-800 text-sm">Supprimer ce document</p>
          <p class="text-xs text-stone-500 mt-0.5">Cette action est irréversible.</p>
        </div>
      </div>
      <div class="flex gap-2 justify-end">
        <button type="button" (click)="cancelDelete()"
          class="px-4 py-2 text-sm font-medium text-stone-600 border border-stone-200 rounded-xl hover:bg-stone-50 transition-colors">
          Annuler
        </button>
        <button type="button" (click)="applyDelete()"
          class="px-4 py-2 text-sm font-medium text-white bg-red-500 hover:bg-red-600 rounded-xl transition-colors">
          Supprimer
        </button>
      </div>
    </div>
  </div>
}
